import { render, staticRenderFns } from "./SubTitleTJ.vue?vue&type=template&id=70322218&scoped=true"
import script from "./SubTitleTJ.vue?vue&type=script&lang=js"
export * from "./SubTitleTJ.vue?vue&type=script&lang=js"
import style0 from "./SubTitleTJ.vue?vue&type=style&index=0&id=70322218&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70322218",
  null
  
)

export default component.exports